export const getSuperbillGoalsData = state => state.superbillGoals.all;
export const getSuperbillGoalData = state => state.superbillGoals.superbillGoal;
export const superbillGoalsIsFetching = state => state.superbillGoals.loading.all;
export const superbillGoalIsFetching = state => state.superbillGoals.loading.superbillGoal;